import { render, staticRenderFns } from "./digital-signage.vue?vue&type=template&id=ab72492c&scoped=true&"
import script from "./digital-signage.vue?vue&type=script&lang=js&"
export * from "./digital-signage.vue?vue&type=script&lang=js&"
import style0 from "./digital-signage.vue?vue&type=style&index=0&id=ab72492c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab72492c",
  null
  
)

export default component.exports